import { Box } from '@primer/react';
import { desktop1920pxOrWider, tabletOrNarrower } from '@upright/ui/common/generic/layout/breakpoint-utils';
import { themeGet } from '@upright/ui/common/generic/theme/custom-theme';
import { ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { url as uprightLogoSymbol } from '../../common/generic/components/icons/logo/logo-symbol.svg';
import { NiceTextInput } from '../../common/generic/components/inputs/nice-text-input';
import { getTextStyle } from '../../common/generic/content/texts/bou-text/text-style';
import { getTitleStyle } from '../../common/generic/content/texts/bou-title/title-style';
import { BouColor } from '../../common/generic/global/bou-colors';
import { BouSpacingLevel, fluidSpacing } from '../../common/generic/layout/bou-spacing';
import { fluidSpaceLg } from '../../common/generic/utilities/fluid/fluid';

export function LoginRoot(props: { children: ReactNode; footer?: ReactNode }) {
  return (
    <LoginBg>
      <LoginRootDiv>
        <Box margin={3}>{props.children}</Box>
        {props.footer && <LoginFooter>{props.footer}</LoginFooter>}
      </LoginRootDiv>
    </LoginBg>
  );
}

const LoginBg = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: ${themeGet('colors.bg.muted')};
`;

const LoginRootDiv = styled.div`
  ${getTextStyle({ size: 'xxs' })}
  display: flex;
  flex-direction: column;
  margin-right: auto;
  margin-left: auto;
  max-width: 300px;
  color: ${BouColor.PLATFORM_TEXT_GRAY_DARK};
  ${fluidSpacing('margin-top', BouSpacingLevel.SMALL)}
  ${desktop1920pxOrWider(css`
    ${fluidSpacing('margin-top', BouSpacingLevel.MEDIUM)}
  `)}
  ${tabletOrNarrower(css`
    ${fluidSpacing(
      'margin-top',
      BouSpacingLevel.EXTRA_LARGE,
    )}// Quickfix, PageArea goes behind top bar on narrow screens due to bad display mode // TODO fix properly before route split
  `)}
  background-color: ${themeGet('colors.bg.default')};
  border: 1px solid ${themeGet('colors.border.default')};
`;

export const LoginUprightLogoSymbol = styled.img.attrs({ src: uprightLogoSymbol })`
  ${fluidSpaceLg('width', 100)};
  margin: 0 auto 2em;
`;

export const LoginTitle = styled.h2`
  ${getTitleStyle({ size: 'h5' })}
  text-align: center;
`;
export const LoginText = styled.p`
  ${getTextStyle({ size: 'xxs' })}
  color: ${themeGet('colors.text.muted')}
`;
export const LoginRow = styled.div`
  ${fluidSpacing('margin-top', BouSpacingLevel.TINY)}
  ${fluidSpacing('margin-bottom', BouSpacingLevel.TINY)}
`;
export const LoginStyledForm = styled.form``;
export const LoginLabel = styled.label`
  ${fluidSpacing('margin-bottom', BouSpacingLevel.MICRO)}
  font-weight: 500;
  display: flex;
  align-items: center;
`;
export const LoginInput = styled(NiceTextInput)``;

export const LoginHintContainer = styled.div`
  ${fluidSpacing('margin-top', BouSpacingLevel.MICRO)}
`;
export const LoginButtonWrap = styled.div`
  ${fluidSpacing('margin-top', BouSpacingLevel.TINYISH)}
`;

export const Divider = styled.div`
  height: 1px;
  background-color: ${BouColor.PLATFORM_BORDER_GRAY_LIGHT};
  text-align: center;
  margin-top: 1.5em;
  margin-bottom: 1.5em;
  > span {
    color: ${BouColor.PLATFORM_TEXT_GRAY};
    background-color: ${BouColor.PLATFORM_BG_WHITE};
    position: relative;
    top: -0.6em;
    padding: 0 1em;
  }
`;

export const SsoButtonsWrap = styled.div`
  margin: 1em 0 0;
  > * + * {
    margin-top: 20px;
  }
`;

const LoginFooter = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 40px;
  text-align: center;
  background-color: ${themeGet('colors.bg.subtle')};
`;
